module.exports = __webpack_public_path__ + "static/media/finish_packing_audio.3935d340.mp3";